import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Auralis render error:', error, info);
  }
  reset = () => {
    this.setState({ hasError: false });
    window.location.href = '/app';
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center px-4" style={{ background: 'var(--aura-bg)' }}>
          <div className="glass rounded-2xl p-10 text-center max-w-md">
            <div className="grid place-items-center w-14 h-14 rounded-2xl mx-auto mb-4 bg-[var(--aura-purple)]/10 text-[var(--aura-purple)]">
              <i className="fa-solid fa-triangle-exclamation text-xl" />
            </div>
            <h2 className="font-display text-2xl mb-2">Something went wrong</h2>
            <p className="text-[var(--aura-ink-soft)] mb-5">Please try again — your data is safe.</p>
            <button data-testid="error-reset-btn" onClick={this.reset} className="aura-btn-gradient text-white font-semibold rounded-full px-6 py-3">
              Back to dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
